export default {
  LOGIN: "connexion",
  SIGNUP: "Regístrate",
  FORGOT_PASSWORD: "¿Se te olvidó tu contraseña?",
  OR_LOGIN_WITH_EMAIL: "O",
  LOGIN_WITH: "Inicia con",
  OR_SIGNUP_WITH_EMAIL: "O puedes registrarte con email",
  EMAIL_FOR_RESET_PASSWORD: "Consultar su correo electrónico",
  AUTHENTICATION_TYPE_SUBTITLE: "Seleccione el identificador que sus usuarios utilizarán para registrarse e iniciar sesión.",
  SIGNING_KEYS_LEVEL: "Nivel",
  SIGNING_KEYS_TENANT: "Inquilino",
  SIGNING_KEYS_OAUTH: "OAuth"
};
